import React from "react";
import {injectIntl} from "react-intl";

class PRCardLightbox extends React.Component {

    render() {
        const { formatMessage } = this.props.intl;
        return (
            <div id="permanent-resident-card" className="light-box-overlay">
                <div className="light-box">
                    <a className="light-box-close" id="prCardLightboxClose" onClick={(e) => this.props.handle(e)}>
                        {formatMessage({id: "content.lightbox.close"})}
                    </a>
                    <p className="header-text">Permanent Resident Card (1997-2010)</p>
                    <img title="Permanent Resident Card 1997-2010)" alt="Permanent Resident Card (1997-2010)"
                         src="/assets-static/images/expire-date-highlight-permanent-resident-card-large.png"/>
                </div>
                <div className="light-box-bg"></div>
            </div>
        )
    }
}

export default injectIntl(PRCardLightbox);
